import { Col, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap"

import PropTypes from 'prop-types'
import React from "react"
import { getPrimaryButtonClass, getPrimaryTextClass } from "helpers/sf_utils"

const DeleteCampaignModal = ({ deleteModalState, onDeleteClick, onCloseClick, textMessage }) => {
  return (
    <Modal isOpen={deleteModalState.action} toggle={onCloseClick} centered={true}>
      <ModalHeader>
        <div className="d-flex justify-content-center">
          <i className={`align-self-bottom label-title bx bxs-error ${getPrimaryTextClass()} me-1`}></i>
          <span className="modal-title">
            Delete Campaign
          </span>
        </div>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={onCloseClick}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col xl={12}>
            <div className="mb-3">
              <Label className="form-label text-muted mb-3">
                {textMessage}
              </Label>
            </div>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <button
          type="button"
          className={`btn ${getPrimaryButtonClass()} ms-2`}
          onClick={() => onDeleteClick(deleteModalState)}
        >
          Yes, delete it
        </button>
        <button
          type="button"
          className="btn btn-light ms-2"
          onClick={onCloseClick}
        >
          Cancel
        </button>
      </ModalFooter>
    </Modal>
  )
}

DeleteCampaignModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  deleteModalState: PropTypes.any,
  textMessage: PropTypes.string
}

export default DeleteCampaignModal
